<fa-icon [icon]="get()" [style.color]="iconColor" class="mr-4" *ngIf="icon" [size]="iconSize"></fa-icon>
